import { FC } from 'react'
import { FiCheck } from 'react-icons/fi'

import CustomText from '../../CustomText'

type CheckListItemProps = {
  description: string
}

export const CheckListItem: FC<CheckListItemProps> = ({ description }: CheckListItemProps) => {
  return (
    <div className={`w-full h-auto flex flex-row gap-x-2 items-center`}>
      <div className="w-[20px] h-[20px] bg-[#ffffff] border-solid border-[1.5px] border-[#5cbdeb] flex flex-row items-center justify-center rounded-full">
        <FiCheck className="w-[12px] h-[12px]" color="#5cbdeb" />
      </div>

      <CustomText
        textLabel={description}
        fontWeight={`font-regular`}
        fontSize="text-[14px]"
        fontColor={`text-black`}
        customClass="text-center"
      />
    </div>
  )
}

export default CheckListItem
